import {
    createStore
} from "vuex";

//创建状态
const state = {
    isLogin: false,
    token: '',
    AdminCache: '',
}
//创建actions
const actions = {
    // 代替mutation进行异步操作
    // 退出登录
    logout(context) {
        context.commit('changeLoginState', false);
        context.commit('saveTokenStorage', '');
        context.commit('saveUserInfoStorage', '');
        sessionStorage.removeItem('isLogin');
        sessionStorage.removeItem('AdminCache');
    }
}
//创建mutataions
const mutations = {
    // 修改state中的数据状态只能通过mutation
    // 更新登录状态  
    changeLoginState(state, isLoginOk) {
        state.isLogin = isLoginOk;
    },
    // 存储token
    saveTokenStorage(state, payload) {
        state.token = payload;
    },
    //存储用户信息
    saveUserInfoStorage(state, payload) {
        state.AdminCache = payload;
    },
    //存储配置信息
    saveAllConfigStorage(state, payload) {
        state.allConfig = payload;
    },
    // 更新token
    updateToken(state, payload) {
        state.token = {
            ...state.info,
            'RefreshToken': payload.RefreshToken,
            'AccessToken': payload.AccessToken,
            'AccessExpiresIn': payload.AccessExpiresIn
        }
        sessionStorage.setItem('token', JSON.stringify(state.token))
    }
}

//创建store
const store = createStore({
    state,
    actions,
    mutations
})
//暴露出去
export default store